<template>
  <div class="w-full">
    <!-- PRELOAD -->

    <!-- v-else -->
    <img
      src="@/assets/images/savannah/hero.jpg"
      class="fixed w-px h-px opacity-0 -z-10"
      alt=""
      ref="heroPic"
      @load="lhero = true"
    />
    <img
      class="fixed w-px h-px opacity-0 -z-10"
      v-for="(col, index) in spectrum"
      :key="index"
      :src="col.car"
      alt=""
    />
    <!-- PRELOAD -->
    <div
      v-if="!lhero"
      class="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-screen"
    >
      <div
        class="bg-[#1B1B1B] absolute load1 top-0 left-0 w-full h-screen z-0"
      ></div>
      <div
        class="bg-[#1B1B1B] absolute load2 top-0 left-0 w-full h-screen z-0"
      ></div>
      <div class="img1">
        <img
          src="@/assets/images/miniLogo.png"
          class="z-[1] zoom img1"
          alt="Logo"
        />
      </div>
    </div>
    <div class="w-full">
      <section
        class="relative w-full heroBG md:min-h-0 min-h-screen md:max-h-none max-h-screen"
      >
        <img
          src="@/assets/images/savannah/hero.jpg"
          class="w-full md:block hidden"
          alt=""
        />
        <div class="absolute top-0 right-0 left-0">
          <div
            class="min-h-screen max-h-none md:w-[90%] w-[95%] max-w-xl mx-auto h-full flex flex-col items-start justify-between md:pt-[20vh] md:pl-10 pt-[15vh] pb-[10vh]"
          >
            <!-- <div class="hidden w-full md:block"></div> -->
            <div class="w-full">
              <h1 class="font-belgiano md:text-[80px] text-[36px]">
                Savannah<span class="text-green">.</span>
              </h1>
              <p class="text-xs font-inter md:text-2xl">
                Starting from ₦{{ prcs.savannah }} million
              </p>
              <div class="flex items-center gap-6 mt-3">
                <p class="text-xs font-inter md:text-lg">
                  {{ downpaymentPercentage }}% down payment
                </p>
                <div class="w-px h-4 bg-realBlack"></div>
                <p class="text-xs font-inter md:text-lg">Spread over 5 years</p>
              </div>
              <router-link :to="{ name: 'order-savannah' }">
                <button
                  class="black-btn w-[clamp(9.375rem,5.869vw+7.174rem,15.625rem)] mt-7"
                >
                  Order Now
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </section>
      <section class="w-full bg-realBlack">
        <div
          class="flex flex-wrap justify-between items-center md:w-[90%] w-[95%] max-w-xl mx-auto py-20 md:gap-4 gap-y-6 md:flex-nowrap"
        >
          <div class="text-center md:w-1/4 w-[50%] text-white">
            <p class="font-inter text-xs uppercase tracking-[1.25px]">
              Dimension
            </p>
            <p class="mt-1 text-sm font-inter md:text-xl">
              L: 5002 W: 1972 H: 1732
            </p>
          </div>
          <div class="w-px h-4 md:block hidden bg-white bg-opacity-40"></div>
          <div class="text-center md:w-1/4 w-[45%] text-white">
            <p class="font-inter text-xs uppercase tracking-[1.25px]">
              Top Speed
            </p>
            <p class="mt-1 text-sm font-inter md:text-xl">180km/H</p>
          </div>
          <div class="w-px h-4 md:block hidden bg-white bg-opacity-40"></div>
          <div class="text-center md:w-1/4 w-[45%] text-white">
            <p class="font-inter text-xs uppercase tracking-[1.25px]">Range</p>
            <p class="mt-1 text-sm font-inter md:text-xl">638km</p>
          </div>
          <div class="w-px h-4 md:block hidden bg-white bg-opacity-40"></div>
          <div class="text-center md:w-1/4 w-[45%] text-white">
            <p class="font-inter text-xs uppercase tracking-[1.25px]">
              Battery
            </p>
            <p class="mt-1 text-sm font-inter md:text-xl">82.28 (KWh)</p>
          </div>
        </div>
      </section>
      <section class="w-full bg-realBlack md:py-20 py-5 block">
        <div class="md:w-[90%] w-[97.5%] max-w-xl md:mx-auto ml-auto">
          <div
            class="md:w-[90%] w-full mx-auto flex flex-col-reverse items-stretch md:gap-11 gap-7"
          >
            <div class="w-full overflow-x-auto">
              <img
                src="@/assets/images/savannah/pilotView.jpg"
                class="md:w-full w-[200%] md:min-w-0 min-w-[200%]"
                alt=""
              />
            </div>
            <div class="relative md:w-1/2">
              <div class="">
                <div class="relative left-0 right-0 w-full text-white">
                  <h3
                    class="capitalize font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px]"
                  >
                    Smarter Drives, Every Mile
                  </h3>
                  <p class="tracking-[1.8px] mt-3 md:text-base text-xs">
                    Say hello to a smoother, more intuitive driving experience
                    with the Savannah's Intelligent Assist Technology, featuring
                    drive mode selection, assisted driving, and an advanced
                    cruise control system that keeps every journey effortless,
                    responsive, and remarkably safe.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="w-full bg-realBlack md:py-20 py-5 block">
        <div class="md:w-[90%] w-[97.5%] max-w-xl md:mx-auto ml-auto">
          <div
            class="md:w-[90%] w-full mx-auto flex flex-col items-stretch md:gap-11 gap-7"
          >
            <div class="w-full overflow-x-auto">
              <img
                src="@/assets/images/savannah/cockpit.jpg"
                class="md:w-full w-[200%] md:min-w-0 min-w-[200%]"
                alt=""
              />
            </div>
            <div class="relative md:w-1/2">
              <div class="">
                <div class="relative left-0 right-0 w-full text-white">
                  <h3
                    class="capitalize font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px]"
                  >
                    In-built Entertainment System
                  </h3>
                  <p class="tracking-[1.8px] mt-3 md:text-base text-xs">
                    Get mesmerized by Savannah's in-built entertainment system,
                    featuring a stunning dual-screen display, immersive audio,
                    and a comprehensive ecosystem that lets you watch, listen,
                    sing, and play
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="w-full bg-realBlack md:py-20 pt-11 pb-9">
        <div class="w-full max-w-[1550px] mx-auto">
          <div class="md:w-[95%] w-full mx-auto">
            <div
              class="flex items-stretch md:flex-row flex-col w-full max-h-[390px] overflow-hidden"
            >
              <div class="md:w-1/2 w-full">
                <img
                  src="@/assets/images/savannah/rearPlatform.png"
                  alt=""
                  class="w-full"
                />
              </div>
              <div class="md:w-1/2 w-full">
                <img
                  src="@/assets/images/savannah/dropDown.jpg"
                  alt=""
                  class="w-full"
                />
              </div>
            </div>
            <div class="md:w-full w-[95%] mx-auto">
              <div
                class="md:w-[80%] w-full mx-auto max-w-xl flex md:flex-row flex-col items-start md:gap-8 md:py-8 pt-7"
              >
                <h3
                  class="capitalize text-white font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px] md:w-2/12 w-full"
                >
                  Luxury in Every Detail
                </h3>
                <p
                  class="md:text-base text-xs tracking-[1.8px] text-white md:w-10/12 w-full mt-3 md:mt-0"
                >
                  The Savannah sets a new benchmark for passenger comfort with
                  its quilted suede interiors, class-leading aisle width,
                  second-row pop-up cup holder, and a 21.4-inch smart rear
                  entertainment screen that transforms every journey into a
                  refined, first-class experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="w-full relative bg-realBlack">
        <img
          class="w-full"
          src="@/assets/images/savannah/seats_as.png"
          alt=""
        />
        <div class="absolute md:bottom-20 bottom-3 left-0 w-full">
          <div class="md:w-[90%] w-[95%] max-w-xl mx-auto">
            <div class="md:w-4/5 w-full mx-auto">
              <h3
                class="capitalize text-white font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px]"
              >
                Transform Your Journey into a Luxurious Retreat
              </h3>
              <p
                class="md:text-base text-xs tracking-[1.8px] mt-3 text-white md:block hidden"
              >
                With Savannah's innovative five-seat design, effortlessly fold
                down the seats to create a spacious king-size bed, converting
                your vehicle into a cozy bedroom sanctuary, perfect for restful
                getaways or impromptu naps.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="w-full bg-realBlack relative">
        <div class="w-[95%] max-w-xl mx-auto md:hidden block pb-12">
          <p class="md:text-base text-xs tracking-[1.8px] text-white">
            With Savannah's innovative five-seat design, effortlessly fold down
            the seats to create a spacious king-size bed, converting your
            vehicle into a cozy bedroom sanctuary, perfect for restful getaways
            or impromptu naps.
          </p>
        </div>
      </section>
      <section class="bg-white md:py-20 md:pt-9">
        <div class="w-full max-w-[1550px] mx-auto">
          <div class="md:w-[95%] w-full mx-auto relative">
            <img
              class="w-full"
              src="@/assets/images/savannah/nature.jpg"
              alt=""
            />
            <!-- <img
              class="w-full md:hidden block"
              src="@/assets/images/savannah/backSideViewMob.png"
              alt=""
            /> -->
            <div class="md:absolute md:bottom-40 left-0 w-full md:pt-0 pt-4">
              <div class="md:w-[90%] w-[95%] max-w-xl mx-auto">
                <div class="md:pl-8 md:w-1/3 w-full">
                  <h3
                    class="capitalize md:text-white text-realBlack md:text-center text-left font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px]"
                  >
                    Drive for Nature
                  </h3>
                  <p
                    class="md:text-base text-xs tracking-[1.8px] mt-3 md:text-white text-realBlack w-full"
                  >
                    Meet Savannah, the electric car inspired by the majestic
                    grasslands that once roamed free. We named our car after
                    this fragile ecosystem to honor its beauty and raise
                    awareness about its decline. Just as the savannah supports
                    diverse wildlife, our car is designed to support a
                    sustainable future. With every drive, we're one step closer
                    to preserving the balance of nature.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="w-full bg-white md:py-20 pt-9">
        <div class="w-full max-w-[1550px] mx-auto">
          <div
            class="md:w-[95%] w-full mx-auto flex flex-col-reverse md:flex-row items-stretch md:gap-6 gap-7"
          >
            <div class="relative w-full md:w-2/5">
              <div>
                <div class="md:w-full w-[95%] mx-auto md:px-8 md:mt-[120px]">
                  <h3
                    class="capitalize text-realBlack font-belgiano md:text-[26px] text-[1rem] tracking-[1.4px] md:mt-4"
                  >
                    Extended Range SUV
                  </h3>
                  <p
                    class="md:text-base text-xs tracking-[1.8px] mt-3 text-realBlack"
                  >
                    With its powerful electric motor and advanced battery
                    technology, you can venture off the beaten path without
                    worrying about running out of juice. Enjoy the thrill of the
                    open road, and the peace of mind that comes with knowing
                    you're driving a sustainable future.
                  </p>
                </div>
              </div>
            </div>
            <img
              src="@/assets/images/savannah/trans.png"
              class="w-full md:w-2/3"
              alt=""
            />
          </div>
        </div>
      </section>
      <section class="w-[95%] max-w-[1550px] mx-auto md:pt-0 pt-8">
        <div class="w-full max-w-xl mx-auto md:pl-8">
          <h2 class="capitalize font-belgiano text-[1rem] md:text-[56px]">
            Go The Distance
          </h2>
        </div>
        <img
          src="@/assets/images/savannah/distance.png"
          alt=""
          class="w-full mt-4 md:mt-8"
        />
        <div class="w-full max-w-xl mx-auto md:pl-8">
          <p
            class="md:text-base text-xs tracking-[1.8px] md:mt-9 mt-4 md:w-2/3 w-full"
          >
            With a single charge, it can travel up to 638 km, effortlessly
            covering long routes like Lagos to Ilorin, Kwara State (301 km) and back with
            a little more juice left to spare. Experience the freedom
            to go further, without worrying about running out of charge.
          </p>
        </div>
      </section>

      <!-- <section class="w-[95%] max-w-[1550px] mx-auto md:pt-[120px] pt-9">
        <div class="w-full max-w-xl md:pl-8">
          <h2 class="capitalize font-belgiano text-[1rem] md:text-[56px]">
            View Our Spectrum
          </h2>
        </div>
      </section>
      <section class="relative w-full overflow-hidden" ref="swipeArea">
        <div
          class="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center z-[-1]"
        >
          <h1
            class="w-full text-newGrey md:text-9xl text-7xl scale-125 font-belgiano font-black text-center md:scale-[2.5] opacity-5"
          >
            SAVANNAH
          </h1>
        </div>
        <div
          class="md:w-full w-[95%] mx-auto flex items-center justify-center mt-20 switchCont"
        >
          <img
            :src="spectrum[activeSpectrum].car"
            class="w-full mx-auto md:w-1/2"
            alt=""
          />
        </div>
      </section>
      <section class="w-[95%] max-w-[1550px] mx-auto md:pb-[120px] pb-9">
        <div class="w-[80%] mx-auto max-w-xl mt-9">
          <div class="flex items-center justify-center w-full">
            <div>
              <p class="text-sm text-newGrey opacity-65">Available colors</p>
              <div class="flex items-center w-full gap-3 mt-1">
                <img
                  class="w-10 h-10 overflow-hidden rounded-full cursor-pointer"
                  :class="[
                    activeSpectrum === index ? 'border-[3px] border-green' : '',
                  ]"
                  v-for="(col, index) in spectrum"
                  :key="index"
                  :src="col.icon"
                  @click="changeCarTo(index)"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section> -->
      <section class="w-[95%] max-w-[1550px] mx-auto py-[60px]">
        <div class="md:w-[80%] w-full mx-auto max-w-xl">
          <div class="w-full">
            <div class="w-full">
              <h6 class="text-lg font-belgiano md:text-2xl mb-2">Specs</h6>
              <div
                class="flex md:grid md:grid-cols-3 items-start flex-wrap w-full justify-between gap-y-4 md:gap-8"
              >
                <div
                  v-for="spec in showAll ? specs : specs.slice(0, 6)"
                  :key="spec.title"
                  class="w-fit md:min-w-fit min-w-[50%] px-2 py-1 md:px-5 md:py-4"
                >
                  <p
                    class="w-full text-sm text-newGrey whitespace-nowrap opacity-65"
                  >
                    {{ spec.title }}
                  </p>
                  <p class="w-full whitespace-nowrap text-realBlack">
                    <!-- <br /> -->
                    {{ spec.value }}
                  </p>
                </div>
              </div>
            </div>
            <div class="w-full" v-if="showAll">
              <div
                class="w-full mt-8"
                v-for="other in otherSpecs"
                :key="other.title"
              >
                <h6 class="text-lg font-belgiano md:text-2xl mb-2">
                  {{ other.title }}
                </h6>
                <div
                  class="flex flex-wrap items-start w-full gap-4 pl-2 mt-2 md:px-7 md:pl-0 md:gap-8"
                >
                  <div
                    class="vehSpec"
                    v-for="otherValue in other.values"
                    :key="otherValue"
                  >
                    <span class="bigDot"></span>
                    <p>{{ otherValue }}</p>
                  </div>
                </div>
              </div>
              <div class="w-full">
                <div class="px-2 py-4 mt-3">
                  <p class="text-lg">
                    <span class="text-sm text-newGrey opacity-65"
                      >Warranty</span
                    >
                    <br />
                    36 Months
                  </p>
                </div>
                <div class="w-full mt-3">
                  <div
                    class="inline-block py-2 pl-3 pr-4 bg-green bg-opacity-10"
                  >
                    <p class="font-inter leading-[26px] text-green">
                      Home charging available
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full">
              <button
                v-if="!showAll"
                @click="showAll = true"
                class="black-btn long mt-7"
              >
                See More
              </button>
              <div class="flex items-center justify-between w-full" v-else>
                <router-link :to="{ name: 'order-savannah' }">
                  <button class="black-btn long mt-7">Order Now</button>
                </router-link>
                <button
                  class="white-btn long mt-7 black-border"
                  @click="showAll = false"
                >
                  See Less
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import col1 from "@/assets/images/savannah/colors/night_black.png";
import col2 from "@/assets/images/savannah/colors/cornet_white.png";
import col3 from "@/assets/images/savannah/colors/particle_blue.png";
import col4 from "@/assets/images/savannah/colors/dust-free_silver.png";
import car1 from "@/assets/images/savannah/colors/black.png";
import car2 from "@/assets/images/savannah/colors/white.png";
import car3 from "@/assets/images/savannah/colors/blue.png";
import car4 from "@/assets/images/savannah/colors/silver.png";
export default {
  data() {
    return {
      lhero: false,
      showAll: false,
      swipe: {
        touchstartX: 0,
        touchendX: 0,
      },
      specs: [
        { title: "Pure Electric Range (km)", value: "638" },
        { title: "Charging Time", value: "Fast charging 0.47 hours" },
        { title: "Fast Charging Capacity (%)", value: "30-80" },
        { title: "Maximum Power (kW)", value: "200 (272Ps)" },
        { title: "Maximum Torque (N·m)", value: "340" },
        { title: "Motor Type", value: "Permanent magnet/synchronous" },
        { title: "Total Motor Power (kW)", value: "200" },
        { title: "Total Motor Horsepower (Ps)", value: "272" },
        { title: "Total Torque (N·m)", value: "340" },
        { title: "Number of Drive Motors", value: "Single motor" },
        { title: "Motor Layout", value: "Post" },
        { title: "Gearbox", value: "Electric vehicle single-speed transmission" },
        { title: "Number of Gears", value: "1" },
        { title: "Transmission Type", value: "Fixed gear ratio gearbox" },
        { title: "Length x Width x Height (mm)", value: "5002x1972x1732" },
        { title: "Body Structure", value: "5-door, 5-seater SUV" },
        { title: "Wheelbase (mm)", value: "3025" },
        { title: "Front Wheelbase (mm)", value: "1680" },
        { title: "Rear Wheelbase (mm)", value: "1650" },
        { title: "Curb Mass (kg)", value: "2228" },
        { title: "Full Load Mass (kg)", value: "2635" },
        { title: "Minimum Turning Radius", value: "6.268" },
        { title: "Maximum Speed (km/h)", value: "180" },
        { title: "Power Consumption (kWh/100km)", value: "14.7" },
        { title: "Electric Energy Equivalent (L/100km)", value: "1.76" },
        { title: "Vehicle Warranty Period", value: "3 years or 100,000 kilometers" },
        { title: "Battery Type", value: "Lithium iron phosphate battery" },
        { title: "Battery Cell Brand", value: "Dong YuanHeng" },
        { title: "Battery Pack Warranty", value: "Lifetime warranty for first owner (liability exemption clause is subject to official regulations)" },
        { title: "Battery Capacity (kWh)", value: "82.28" },
        { title: "Battery Charging", value: "Fast charging 0.47 hours, Fast charging port" },
        { title: "Fast Charging Port Location", value: "Right fuel tank" },
        { title: "Slow Charging Port Location", value: "Right fuel tank" },
        { title: "Battery Temperature Management", value: "Low temperature heating, Liquid cooling" },
        { title: "VTOL Mobile Power Station", value: "Standard" },
        { title: "VTOL Maximum External Discharge Power", value: "3.8kW" },
        { title: "Drive Mode", value: "Rear-engine, rear-wheel drive" },
        { title: "Front Suspension Type", value: "McPherson independent suspension" },
        { title: "Rear Suspension Type", value: "Multi-link independent suspension" },
        { title: "Steering Type", value: "Electric power steering" },
        { title: "Body Structure", value: "load-bearing" },
        { title: "Front Brake Type", value: "Ventilated disc type" },
        { title: "Rear Brake Type", value: "Ventilated disc type" },
        { title: "Parking Brake Type", value: "Electronic parking brake" },
        { title: "Front Tire Specifications", value: "265/45 R21" },
        { title: "Rear Tire Specifications", value: "265/45 R21" },
      ],
      otherSpecs: [
        {
          title: "Active Safety",
          values: [
            "ABS anti-lock braking system: Standard",
            "Braking force distribution (EBD/CBC, etc.): Standard",
            "Brake assist (EBA/BA, etc.): Standard",
            "Traction control (TCS/ASR, etc.): Standard",
            "Vehicle stability system (ESP/DSC, etc.): Standard",
            "Lane Departure Warning",
            "Forward Collision Warning",
            "Rear Collision Warning",
            "Reversing side warning",
            "DOW door opening warning",
            "Active braking: Standard",
            "Lane change assistance: Standard",
            "Lane Keeping Assist System: Standard",
            "Lane centering: Standard",
            "Fatigue driving tips: Standard",
            "Active DMS fatigue detection: Standard",
            "Roadside vital signs detection: Standard",
            "Road traffic sign recognition: Standard",
            "Traffic lights recognition",
          ],
        },
        {
          title: "Passive Safety",
          values: [
            "Front airbags: Main driver's seat + co-pilot seat",
            "Side airbags: front row",
            "Side curtain airbags: Standard",
            "Seat belt not fastened reminder: Standard",
            "Tire pressure monitoring system: Tire pressure display",
            "Child seat interface (ISOFIX): Standard",
          ],
        },
        {
          title: "Auxiliary/Control Configuration",
          values: [
            "Parking radar: forward + back",
            "Front vehicle departure reminder: Standard",
            "Driving assistance images: Reversing image, 360° panoramic images, Transparent images",
            "Cruise control system: Cruise control, Adaptive cruise control, Full-speed adaptive cruise control",
            "Automatic Lane Change Assist: Standard",
            "Automatic exit/entry of ramp: Standard",
            "Navigation-assisted driving",
            "Assisted driving level: Level 2",
            "Automatic parking: Standard",
            "Track reverse: Standard",
            "Memory Parking: Standard",
            "Automatic parking (AUTOHOLD): Standard",
            "LR Start Assist (HAC): Standard",
            "LR Descent Control (HDC): Standard",
          ],
        },
        {
          title: "Driving Mode",
          values: [
            "Sports",
            "ECO/Economy",
            "Standard comfort",
            "Braking Energy Regeneration System: Standard",
            "Comfort braking: Standard",
            "Low speed driving warning sound: Standard",
          ],
        },
        {
          title: "External Configuration",
          values: [
            "Skylight Type: Segmented panoramic sunroof",
            "Retractable sunroof: Standard",
            "Smart dimming skylight",
            "Roof rack: Standard",
            "Sports appearance package",
            "Electric spoiler",
            "Active closed grille: Standard",
            "Aluminum alloy wheels: Standard",
            "Side pedals",
            "Frameless design doors: Standard",
            "Hidden door handles: Standard",
            "Tow hook",
          ],
        },
        {
          title: "Internal Configuration",
          values: [
            "Steering wheel material: cortex / Genuine Leather",
            "Steering wheel adjustment: Up and down + front and back",
            "Electric steering wheel adjustment",
            "Steering wheel functions: Multi-function control, heating",
            "Gear shifting: Electronic hand gear shift",
            "Trip computer screen: color",
            "LCD instrument style: Full LCD",
            "LCD instrument size (inches): 8.8",
            "Electric suction door",
            "Service-assisted tailgate",
            "Electric tailgate position memory: Standard",
            "Central locking system in the car: Standard",
            "Remote control key type: Smart remote control key, Mobile Bluetooth Key, NFC/ID keys",
            "Keyless entry: Main driver's seat",
            "Keyless start: Standard",
            "Remote Start: Standard",
            "Remote control mobile vehicle: Standard",
            "Head-up display (HUD): Standard",
            "Built-in driving recorder: Standard",
            "Active Noise Cancellation",
            "Mobile phone wireless charging: Standard",
            "Maximum power of mobile phone wireless charging (W): 50",
            "Luggage compartment 12V power socket",
          ],
        },
        {
          title: "Seat Configuration",
          values: [
            "Seat material: imitation leather",
            "Sports style seats: 2+3",
            "Electric seat adjustment: Main driver's seat + co-pilot seat",
            "Overall adjustment of the driver's seat: Move forward and backward, Backrest angle, Height adjustment, headrest",
            "Local adjustment of the driver's seat: waist",
            "Passenger seat overall adjustment: Move forward and backward, Backrest angle",
            "Passenger seat partial adjustment: headrest",
            "Second row seat overall adjustment: Backrest angle adjustment, Leg support, heating",
            "Front seat functions: heating, ventilation, Memory (main driver), Massage (driver's seat)",
            "Front/rear armrests: front row + back row",
            "Rear cup holder: Standard",
            "Heated/cooled cup holders",
            "Rear seat folding ratio: 40/60",
            "Electric folding rear seats",
            "Second row small table",
          ],
        },
        {
          title: "Smart Connectivity",
          values: [
            "Central control screen size (inches): 15.6",
            "Center console color screen resolution: 2.5K",
            "Satellite navigation system: Standard",
            "Navigation traffic information display: Standard",
            "Map Brand: Gaode",
            "Roadside assistance service",
            "Bluetooth/car phone: Standard, CarPlay",
            "Mobile Internet Mapping: Carlink",
            "Internet of Vehicles: HUAWEI HiCar, Standard",
            "4G/5G network: 4G",
            "OTA upgrade: Standard",
            "Facial Recognition: Standard",
            "Voiceprint recognition",
            "Emotion Recognition",
            "Voice recognition control system: Standard",
            "Voice wake-up function: Standard",
            "Voice wake-up recognition function by region: Main driver + co-pilot + Second row",
            "Continuous speech recognition: Standard",
            "Seeing is telling: Standard",
            "Wi-Fi hotspots: Standard",
          ],
        },
        {
          title: "Audio and Video Entertainment",
          values: [
            "App Store: Standard",
            "Multimedia Interface: USB/Type-C",
            "Number of USB/Type-C ports: 1 in the front row + 2 in the back row",
            "USB/Type-C maximum charging power: Front row 18W, Back row 18W",
            "Rear LCD screen: 15.6",
            "Simulated sound waves: Standard",
            "Karaoke function",
            "Number of speakers: 20",
            "Seat speakers (headrest/shoulder): Standard",
          ],
        },
        {
          title: "Lighting Configuration",
          values: [
            "Low beam: led",
            "High beam: led",
            "Daytime running lights: Standard",
            "Automatic headlights: Standard",
            "Headlight height adjustment: Standard",
            "Adaptive Front Steering (AFS)",
            "Interior ambient lighting: 64 colors",
            "Active ambient lighting",
            "Headlights delayed off: Standard",
          ],
        },
        {
          title: "Glass/Rearview Mirror",
          values: [
            "Power windows: front row + back row",
            "One-touch window lift: whole vehicle",
            "Window anti-pinch function: Standard",
            "Multi-layer soundproof glass: Front row + back row",
            "Electric dimming of the front windshield",
            "Heated water nozzle",
            "Exterior rearview mirror function: Electric adjustment, heating, Electric folding, memory, Automatically tilt down when reversing, Automatic folding when locking the car",
            "Interior rearview mirror function: Automatic in-glare, Streaming",
            "Car makeup mirror: Passenger seat + lighting, Main driving seat + no lighting",
            "Rear privacy glass",
            "Car sunshade: Rear window side sunshade",
            "Rain-sensing wipers: Standard",
          ],
        },
        {
          title: "Air Conditioning/Refrigerator",
          values: [
            "Air conditioning control method: automatic",
            "Rear air outlet: Standard",
            "Temperature zone control: Dual-zone air conditioning",
            "In-car PM2.5 filter: Standard",
            "Car air purifier: Standard",
            "Car fragrance device: Standard",
            "Car refrigerator: Standard",
            "Car refrigerator function: heating, refrigeration",
          ],
        },
        {
          title: "Intelligent Configuration",
          values: [
            "Assisted driving operating system: eπ PILOT",
            "In-vehicle intelligent system: eπ OS",
            "In-vehicle smart chip: Qualcomm Snapdragon 8155",
            "Mobile App remote control: Remote Control, Charging Management, Service Appointment",
            "Heat pump management system: Standard",
          ],
        },
        {
          title: "Sensors & Cameras",
          values: [
            "Number of external cameras: 6",
            "Number of cameras in the car: 2",
            "Number of ultrasonic radars: 12",
            "Number of millimeter-wave radars: 2",
          ],
        },
        {
          title: "Optional Package",
          values: [
            "Optional exterior: Customized optional wheels and brakes package",
            "Smart Starlight Grille: Hidden grille lights, multi-scene intelligent lighting language (Optional: 4,000 yuan)",
            "Zero Gravity Seat Package: 21-way Comfortable/0 knot lines, double-layer laminated noise reduction glass, 20 speakers + four-way lin aviation small table, luxury soft pillow, luxury rearview mirror, signalizes (Optional: 10,000 yuan)",
            "Quiet Comfort Package (Limited Time Gift)",
          ],
        },
      ],
      spectrum: [
        {
          icon: col1,
          car: car1,
        },
        {
          icon: col2,
          car: car2,
        },
        {
          icon: col3,
          car: car3,
        },
        {
          icon: col4,
          car: car4,
        },
      ],
      activeSpectrum: 0,
    };
  },
  computed: {
    downpaymentPercentage() {
      return this.$store.getters.downPayment;
    },
    mobile() {
      return window.innerWidth <= 768;
    },
    prcs() {
      return this.$store.getters.dispPrices;
    },
  },
  methods: {
    handleSwipe() {
      if (this.swipe.touchendX < this.swipe.touchstartX) {
        if (this.activeSpectrum < this.spectrum.length - 1) {
          this.changeCarTo(this.activeSpectrum + 1);
        }
      }
      if (this.swipe.touchendX > this.swipe.touchstartX) {
        if (this.activeSpectrum > 0) {
          this.changeCarTo(this.activeSpectrum - 1, true);
        }
      }
    },
    async changeCarTo(index, reverse = false) {
      const changeTo = async (index) => {
        this.activeSpectrum = index;
      };
      if (reverse) {
        if (this.activeSpectrum !== 0) {
          gsap.to(".switchCont", {
            xPercent: 110,
            duration: 0.4,
            ease: "Power4.in",
            async onComplete() {
              await changeTo(index);
              gsap.set(".switchCont", {
                xPercent: -110,
                onComplete() {
                  gsap.to(".switchCont", {
                    xPercent: 0,
                    duration: 0.6,
                    ease: "Power4.out",
                  });
                },
              });
            },
          });
        }
      } else {
        if (this.activeSpectrum !== index) {
          gsap.to(".switchCont", {
            xPercent: -110,
            duration: 0.4,
            ease: "Power4.in",
            async onComplete() {
              await changeTo(index);
              gsap.set(".switchCont", {
                xPercent: 110,
                onComplete() {
                  gsap.to(".switchCont", {
                    xPercent: 0,
                    duration: 0.6,
                    ease: "Power4.out",
                  });
                },
              });
            },
          });
        }
      }
    },
  },
  watch: {
    lhero() {
      if (this.lhero === true) {
        this.$refs.swipeArea.addEventListener("touchstart", (e) => {
          this.swipe.touchstartX = e.changedTouches[0].screenX;
        });
        this.$refs.swipeArea.addEventListener("touchend", (e) => {
          this.swipe.touchendX = e.changedTouches[0].screenX;
          this.handleSwipe();
        });
      }
    },
  },
};
</script>

<style scoped >
.heroBG {
  background-image: url("@/assets/images/savannah/hero.jpg");
  background-position: top right;
  background-size: cover;
}
@media (max-width: 768px) {
  .heroBG {
    background-position: 43% bottom;
    background-image: url("@/assets/images/savannah/hero.jpg");
  }
}
.specBack {
  background-image: url("@/assets/svgs/greyLogo.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}

.vehSpec {
  @apply flex items-center gap-3 md:w-auto w-full;
}
.bigDot {
  @apply inline-block w-2 h-2 rounded-full bg-green bg-opacity-65;
}
</style>
